module.exports = __webpack_public_path__ + "img/version-management-white.0cbb87f7.svg";